<template>
<div style="height: 100%;width: 100%">
  <div style="height: 1px"></div>
  <div class="nothing-data" v-if="alarmData.length === 0"></div>
  <div v-else class="box-three">
    <div class="item-line">
      <el-row>
        <el-col :span="15">
          <div class="left-img1"></div>
        </el-col>
        <el-col :span="9">
          <div class="right-text">
            <span>{{getAlarmType(alarmData[0].alarmtype)}}</span>
            <span style="color:#00e7ff;font-size: 16px">{{alarmData[0].alarmcount}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="item-line" v-if="alarmData[1]">
      <el-row>
        <el-col :span="15">
          <div class="left-img2"></div>
        </el-col>
        <el-col :span="9">
          <div class="right-text">
            <span>{{getAlarmType(alarmData[1].alarmtype)}}</span>
            <span style="color:#00e7ff;font-size: 16px">{{alarmData[1].alarmcount}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="item-line" v-if="alarmData[2]">
      <el-row>
        <el-col :span="15">
          <div class="left-img3"></div>
        </el-col>
        <el-col :span="9">
          <div class="right-text">
            <span>{{getAlarmType(alarmData[2].alarmtype)}}</span>
            <span style="color:#00e7ff;font-size: 16px">{{alarmData[2].alarmcount}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'indexTopThree',
  props: {
    AlarmTypeTopThree: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      alarmArr: [],
      alarmData: []
    }
  },
  created () {
    // 报警类型TOP3
    this.alarmArr = this.AlarmTypeTopThree
    this.getRanking()
  },
  mounted () {
  },
  methods: {
    getRefresh (arr) {
      // console.log('报警类型TOP3')
      this.alarmData = []
      this.alarmArr = arr
      this.getRanking()
    },
    // 排序
    getRanking () {
      // let arr = []
      let data = this.alarmArr
      // console.log(999, this.alarmArr)
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < i; j++) {
          if (parseInt(data[j].alarmcount) < parseInt(data[i].alarmcount)) {
            let swap = data[j]
            data[j] = data[i]
            data[i] = swap
          }
        }
      }
      let arr3 = data.slice(0, 3)
      // console.log('排序1', arr3)
      this.alarmData = arr3
    },
    getAlarmType (atype) {
      return this.commonType.getAlarmType(atype)
    }
  }
}
</script>

<style scoped>
  .box-three{
    position: relative;
    width: 100%;
    height: 154px;
    top: 50%;
    margin-top: -77px;
  }
  .item-line{
    height: 53px;
  }
  .left-img1{
    float: right;
    width: 150px;
    height: 51px;
    background: url("../../../assets/SHscreen/index_pyramid_3.png") no-repeat;
    background-size: 100% 100%;
  }
  .left-img2{
    float: right;
    width: 150px;
    height: 51px;
    background: url("../../../assets/SHscreen/index_pyramid_2.png") no-repeat;
    background-size: 100% 100%;
  }
  .left-img3{
    float: right;
    width: 150px;
    height: 51px;
    background: url("../../../assets/SHscreen/index_pyramid_1.png") no-repeat;
    background-size: 100% 100%;
  }
  .right-text{
    font-size: 14px;
    margin-top: 20px;
    color: white;
    width: 110px;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexTopThree.vue